// OneDrive:IgnoreCodeCoverage
import { encodePath } from '@ms/odsp-utilities/lib/path/Path';

export * from '@ms/odsp-utilities/lib/path/Path';

export function getFolderNameFromPath(itemUrl: string): string {
    let index = itemUrl.lastIndexOf('/');
    return index >= 0 ? itemUrl.substring(index + 1) : itemUrl;
}

export function getSharePointPath(encodedUrl: string): string {
    return decodeURI(encodedUrl);
}

export function canonicalizeUrl(url: string) {
    let decodedUrl;
    try {
        decodedUrl = decodeURI(url);
    } catch (e) {
        decodedUrl = url;
    }
    if (decodedUrl === url) {
        // the url is decoded, it's not real supported url format, make sure it's encoded properly before sending to URI class which
        // only supports encoded url as input.
        url = encodePath(url, true);
    } else {
        // encodeURI API doesn't encode # path. Here for openUrl we know # is path, not Hash, so encode it properly "manually".
        url = url.replace("#", "%23");
    }

    return url;
}

export function canonicalizeDecodedUrl(url: string) {
    if (url && url.indexOf("?") < 0) {
        url = encodeURI(url);
        // encodeURI API doesn't encode # path. Here for openUrl we know # is path, not Hash, so encode it properly "manually".
        url = url.replace(/#/g, "%23");
    }
    return url;
}

export function getDecodedUrl(url: string) {
    let segments = url.split('/');
    if (segments.length > 3) {
        for (let i = 3; i < segments.length; i++) {
            segments[i] = decodeURIComponent(segments[i]);
        }

        return segments.join('/');
    }

    return url;
}
